module.exports = __webpack_public_path__ + "img/GDQ-matcirkel_60.107cda7b.gif";